module.exports = __webpack_public_path__ + "img/icon1.29e71ae1.png";